module.exports = __webpack_public_path__ + "static/media/logo.eeef84d3.png";